import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

/**
 * Modern standalone application bootstrap
 * Replaces platformBrowserDynamic().bootstrapModule()
 */
bootstrapApplication(AppComponent, appConfig)
  .then((ref) => {
    // Ensure Angular destroys itself on hot reloads
    if (window['ngRef']) {
      window['ngRef'].destroy();
    }
    window['ngRef'] = ref;
  })
  .catch((err) => console.error(err));
